var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoWhite = function SvgLogoWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1002 349"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h607.7v142.4H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M0 0h348.1v348.1H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M0 0h348.1v348.1H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M0 0h348.1v348.1H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i",
    d: "M0 0h348.1v348.1H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "k",
    d: "M0 0h348.1v348.1H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "m",
    d: "M0 0h348.1v348.1H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "o",
    d: "M0 0h348.1v348.1H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "q",
    d: "M0 0h348.1v348.1H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 103.8)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M-.1 19.2h14.3L25.8 81l11.8-61.8h14.3l-18.6 84.6H18.5L-.1 19.2",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M68.3 123h15.1l20 84.6H89.2L85.6 191H65.9l-3.7 16.6H47.9L68.3 123m-7.8-12.9c0-3.4 2.8-6.2 6.2-6.2 3.5 0 6.2 2.9 6.2 6.2 0 3.5-2.8 6.2-6.2 6.2-3.4 0-6.2-2.7-6.2-6.2Zm22.7 68.7-7.3-35.1-7.4 35.2h14.7v-.1Zm-4.5-68.7c0-3.4 2.8-6.2 6.1-6.2 3.5 0 6.2 2.9 6.2 6.2 0 3.5-2.8 6.2-6.2 6.2-3.3 0-6.1-2.7-6.1-6.2Zm29.6 12.9h13.2l19.8 50.1v-49.9h14.1v84.4h-13.2l-19.9-49.3v49.3h-14V123m58 0h39.4v13.7h-25.3v22.1h18.8v12.4h-18.8v22.9h25.3v13.5h-39.4V123m47.9 0h22.3c13.9 0 23.4 9.1 23.4 25.7v11.2c0 11.3-4.6 18.5-11.9 22l11.9 25.8h-15.4l-9.4-22.4h-6.7v22.3h-14.2V123m20.7 48.9c5.9 0 11.2-2.3 11.2-12.5v-10.8c0-9.6-5.3-12-11.2-12h-6.5v35.3h6.5Zm34.2-48.9h14.1v71.1h22.9v13.5h-37V123m43 0h39.4v13.7h-25.3v22.1H345v12.4h-18.8v22.9h25.3v13.5h-39.4V123m48 0h23c13.8 0 23.4 8.9 23.4 26v32.5c0 17-9.6 26-23.4 26h-23V123m21.4 71.2c6.1 0 11.2-2.5 11.2-14.8v-29.5c0-8.4-3.2-13.3-11.2-13.3h-7.3v57.6h7.3Zm34.4-71.2h39.4v13.7H430v22.1h18.8v12.4H430v22.9h25.3v13.5h-39.4V123m48 0h13.2l19.8 50.1v-49.9h14.2v84.4h-13.2L478 158.3v49.3h-14.1V123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533 161.7c-2.8-.4-5.6-.7-8.3-.8 2.7.1 5.5.4 8.3.8Zm-8.4 11.9c7-.4 13.9-1.9 20.3-3.7-6.4 1.9-13.2 3.4-20.3 3.7Zm48.8-10.6c-5.5.5-11.2 1.7-17.1 3.4 5.8-1.7 11.6-2.9 17.1-3.4Zm7.4-3.9c-6.7-1.6-13.2-2.4-19.4-2.4-8.7 0-18 1.6-27.7 4.8 9.7-3.2 19-4.8 27.7-4.8 6.2 0 12.7.8 19.4 2.4Zm-26.5 8.5 5.1 1.5c-1.7-.5-3.5-1-5.1-1.5Zm19.1-4.6c-5 1.6-10.5 3.2-16.1 4.2 5.6-1.1 11-2.6 16.1-4.2Zm-22 4.9c-1.3.1-2.6.2-4 .3 1.4 0 2.7-.1 4-.3Zm40.8 7.6h-3 1.5c.5.1 1 .1 1.5 0Zm11.1-26.1c1.3-.4 2.7-.8 4-1.2-1.3.4-2.6.8-4 1.2Zm4.3 7.8c-1.1-.1-2.3-.1-3.4-.1 1.2 0 2.3.1 3.4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0089A9",
    fillRule: "nonzero",
    d: "M606.3 147.8c-.3 0-.5.1-.8.2-.4.2-.7.4-1.1.7l-.7.4c-.2.1-.3.2-.5.3 1.3-.4 2.7-.8 4-1.2-.1-.1-.2-.2-.3-.2-.1-.1-.3-.2-.6-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007EA2",
    fillRule: "nonzero",
    d: "M600.7 150.9c-1.5.8-3 1.5-4.4 2.1 3.6 1.1 7.5 2.2 11.4 3v-6.7c0-.3-.1-.7-.4-1-1.3.4-2.6.8-4 1.2-.9.4-1.8 1-2.6 1.4Zm-55-2.2c-6.5.3-12.5 2.1-18.3 5.4 3-.8 5.8-1.8 8.5-2.7 3.3-1.1 6.5-2 9.8-2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008190",
    fillRule: "nonzero",
    d: "M533 161.7c-2.8-.4-5.6-.7-8.3-.8v3.4c2.8-.8 5.6-1.7 8.3-2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007B8C",
    fillRule: "nonzero",
    d: "M584 155.4h-1c-6.4-.2-12.6-2.1-17.9-3.9-6-2-11.7-3-17.1-3-.8 0-1.5 0-2.3.1-3.2.7-6.5 1.6-9.8 2.7-2.7.9-5.6 1.8-8.5 2.7-.2.1-.3.2-.5.3-.7.4-2.1 1.6-2.2 3v3.6c2.7.1 5.5.4 8.3.8.3-.1.5-.2.8-.3 9.7-3.2 19-4.8 27.7-4.8 6.2 0 12.7.8 19.4 2.4 1 .2 1.9.5 2.9.7 7.1-1.8 14-2.7 20.5-2.7 1.1 0 2.3 0 3.4.1v-1.2c-4-.8-7.8-1.9-11.4-3-4.2 1.7-8.3 2.5-12.3 2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007B8C",
    fillRule: "nonzero",
    d: "M545.7 148.7c-3.2.7-6.5 1.6-9.8 2.7-2.7.9-5.6 1.8-8.5 2.7 3-.8 5.8-1.8 8.5-2.7 3.3-1.1 6.5-2 9.8-2.7Zm50.5 4.3c3.6 1.1 7.5 2.2 11.4 3-3.9-.8-7.7-1.9-11.4-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007A8C",
    fillRule: "nonzero",
    d: "M583.7 159.9c1.8.5 3.6 1 5.4 1.6 5.7 1.9 12 3.8 18.5 5.1v-9.3c-1.1-.1-2.3-.1-3.4-.1-6.5-.1-13.4.9-20.5 2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0097BB",
    fillRule: "nonzero",
    d: "M551.4 167.9c1-.1 1.9-.2 2.9-.3-.3-.1-.7-.2-1-.3-.7.2-1.3.4-1.9.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0091B9",
    fillRule: "nonzero",
    d: "M590.7 175.6h-1.5c-10.7-.3-21-3.5-29.9-6.4-1.7-.6-3.4-1.1-5.1-1.5-.9.1-1.9.2-2.9.3-2.1.7-4.3 1.4-6.5 2-6.4 1.8-13.2 3.3-20.3 3.7v4c0 .5.2.9.6 1.2.2.2.5.3.8.3.2 0 .4 0 .6-.2l1-.6c6.4-3.7 13-5.5 20.3-5.5 5.2 0 10.8 1 16.6 2.9 5.4 1.8 11.8 3.7 18.4 3.9h1.1c5.7 0 11.4-1.5 17.4-4.7.3-.2.6-.3.9-.5-3.3.6-6.7 1-10.1 1.1h-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0085B1",
    fillRule: "nonzero",
    d: "M553.3 167.3c.3.1.6.2 1 .3.2 0 .4-.1.6-.1-.4-.1-.7-.2-1.1-.3-.2 0-.4.1-.5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0082B0",
    fillRule: "nonzero",
    d: "M606.2 167.1c-7.7 2.4-16.2 4.6-25 4.8h-3c-8.2-.3-16.2-2.2-23.4-4.3-.2 0-.4.1-.6.1l5.1 1.5c8.8 2.9 19.2 6.1 29.9 6.4h3c3.4-.1 6.8-.5 10.1-1.1.8-.4 1.6-.9 2.4-1.4l.8-.5c1.1-.7 2.2-1.7 2.2-3.9v-1.1c-.2-.1-.4-.1-.6-.2-.3-.2-.6-.3-.9-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0082B0",
    fillRule: "nonzero",
    d: "M559.4 169.2c8.8 2.9 19.2 6.1 29.9 6.4-10.8-.4-21.1-3.5-29.9-6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007EAC",
    fillRule: "nonzero",
    d: "M553.7 167.2c.4.1.7.2 1.1.3.8-.1 1.6-.2 2.4-.4 5.6-1 11.1-2.6 16.1-4.2-5.5.5-11.2 1.7-17.1 3.4-.8.4-1.7.6-2.5.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007DAC",
    fillRule: "nonzero",
    d: "M554.8 167.5c7.3 2.2 15.2 4.1 23.4 4.3h3c8.8-.3 17.3-2.4 25-4.8-9.1-2.9-17.9-4.4-26-4.4-2.2 0-4.5.1-6.8.3-5 1.6-10.5 3.2-16.1 4.2-.9.2-1.7.3-2.5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008190",
    fillRule: "nonzero",
    d: "M532.5 164.5c-2.4 0-4.9.1-7.4.4 6.2 1.7 12.9 3.1 19.6 3.3h2.8c1.3 0 2.7-.1 4-.3l1.8-.6c-7.3-1.9-14.2-2.8-20.8-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007F8F",
    fillRule: "nonzero",
    d: "M551.4 167.9c-1.3.1-2.6.2-4 .3h-2.8c-6.8-.2-13.4-1.6-19.6-3.3-.1 0-.3 0-.4.1v8.7c7-.4 13.9-1.9 20.3-3.7 2.2-.7 4.4-1.4 6.5-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007589",
    fillRule: "nonzero",
    d: "M532.5 164.5c6.6 0 13.5 1 20.7 2.9h.1c.1 0 .3-.1.4-.1-1.8-.6-3.6-1.1-5.3-1.7l-3.9-1.2c-3.9-1.1-7.7-2-11.5-2.5-2.7.9-5.5 1.8-8.4 2.6v.5c.1 0 .3.1.4.1 2.6-.5 5.1-.6 7.5-.6Zm.5-2.8c-2.7.9-5.5 1.8-8.4 2.6 2.9-.8 5.7-1.7 8.4-2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007589",
    fillRule: "nonzero",
    d: "M553.7 167.2c-.1 0-.3.1-.4.1h-.1.1c.1 0 .3-.1.4-.1Zm-21.2-2.7c6.6 0 13.5 1 20.7 2.9-7.2-2-14.1-2.9-20.7-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007489",
    fillRule: "nonzero",
    d: "M607.1 167.3c.2.1.4.1.6.2v-.9c-.5.2-1 .3-1.5.5.3 0 .6.1.9.2Zm-82.5-2.5v.2c.1 0 .3 0 .4-.1-.1-.1-.2-.1-.4-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007489",
    fillRule: "nonzero",
    d: "M524.6 164.8c.1 0 .3.1.4.1-.1-.1-.2-.1-.4-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007086",
    fillRule: "nonzero",
    d: "m544.5 164.3 3.9 1.2c1.7.6 3.5 1.1 5.3 1.7.8-.3 1.7-.5 2.5-.8 5.9-1.8 11.6-2.9 17.1-3.4 1.1-.3 2.2-.7 3.2-1 2.4-.8 4.8-1.5 7.2-2.1-1-.3-1.9-.5-2.9-.7-6.7-1.6-13.2-2.4-19.4-2.4-8.7 0-18 1.6-27.7 4.8-.3.1-.5.2-.8.3 3.8.4 7.7 1.3 11.6 2.4Zm-10.7-2.8c-.3.1-.5.2-.8.3.2-.1.5-.2.8-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007086",
    fillRule: "nonzero",
    d: "M533 161.7c3.7.6 7.6 1.4 11.5 2.5-3.9-1-7.8-1.9-11.5-2.5Zm50.7-1.8c-2.4.6-4.7 1.3-7.2 2.1-1 .3-2.1.7-3.2 1 2.3-.2 4.6-.3 6.8-.3 8.2 0 16.9 1.5 26 4.4.5-.2 1-.3 1.5-.5-6.6-1.2-12.9-3.2-18.5-5.1-1.8-.6-3.6-1.2-5.4-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007086",
    fillRule: "nonzero",
    d: "M583.7 159.9c1.8.5 3.6 1 5.4 1.6-1.8-.6-3.6-1.2-5.4-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.6 222.4c-3.5-.9-6.8-2-10-3 3.2 1 6.6 2.1 10 3Zm-82.9 1.2c5.8-1.2 11.4-3 16.4-4.6-5 1.7-10.6 3.4-16.4 4.6Zm34.3 11.2c-1.8-.6-3.6-1.1-5.3-1.7 1.7.6 3.4 1.2 5.3 1.7Zm4.4-10.4c-7.7.4-15.9 1.9-24.4 4.7-.3.1-.5.2-.8.3.3-.1.5-.2.8-.3 8.5-2.8 16.7-4.4 24.4-4.7Zm-37.6 16.9h3-1.5c-.6.1-1 0-1.5 0Zm24.1-5.5h2.8-2.8Zm-19.6-3.3c-1.9.2-3.8.5-5.7.8 1.9-.3 3.8-.6 5.7-.8Zm55.1-2.2c6.1 0 12.6.8 19.3 2.5-6.7-1.7-13.1-2.5-19.3-2.5Zm-2.5 16h1.1c.6 0 1.2 0 1.8-.1h-3.6c.2.1.5.1.7.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008CCF",
    fillRule: "nonzero",
    d: "M607.6 217.3V216c0-.4-.1-.9-.7-1.3-.2-.1-.4-.2-.7-.2-.3 0-.5.1-.8.2-.4.2-.7.4-1.1.7l-.7.4c-1.1.6-2.1 1.3-3.1 1.8-1.2.6-2.3 1.2-3.5 1.6.2.1.3.1.5.2 3.6-.5 6.9-1.3 10.1-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0076BE",
    fillRule: "nonzero",
    d: "M607.6 222.4v-5.1c-3.2.9-6.6 1.6-10 2.1 3.2 1 6.6 2.1 10 3Zm-61.6-4.9c2.7-.7 5.4-1.4 8-1.9-2.1-.3-4.1-.4-6.1-.4-7.5 0-14.4 1.9-21.1 5.7-.7.4-1.9 1.4-2.1 2.7 5.8-1.2 11.4-3 16.4-4.6 1.7-.5 3.3-1 4.9-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0075BE",
    fillRule: "nonzero",
    d: "M597.2 219.2c-.3.1-.5.2-.8.3.4-.1.9-.1 1.3-.2-.2 0-.4 0-.5-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006EB8",
    fillRule: "nonzero",
    d: "M538.2 229.4c-3.9-.6-7.8-.9-11.5-.9h-2.1v2.3c1.5.5 2.9.9 4.5 1.4 3.2-.9 6.2-1.9 9.1-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006EB8",
    fillRule: "nonzero",
    d: "M524.6 230.8v2.5c1.5-.4 3-.7 4.5-1.1-1.5-.5-3-.9-4.5-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0066B1",
    fillRule: "nonzero",
    d: "M538.2 229.4c.3-.1.5-.2.8-.3 8.5-2.8 16.7-4.4 24.4-4.7 1.1-.1 2.2-.1 3.3-.1 7.1 0 14.5 1.1 22.3 3.2 6.4-1.6 12.7-2.5 18.7-2.7v-2.4c-3.5-.9-6.8-2-10-3-.4.1-.9.1-1.3.2-4.2 1.7-8.3 2.5-12.4 2.5h-1c-6.4-.2-12.6-2.1-17.9-3.9-3.8-1.2-7.4-2.1-11-2.6-2.6.5-5.3 1.1-8 1.9-1.6.4-3.2.9-4.9 1.5-5.1 1.7-10.6 3.4-16.4 4.6v4.8h2.1c3.6 0 7.4.3 11.3 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0066B1",
    fillRule: "nonzero",
    d: "M554 215.7c-2.6.5-5.3 1.1-8 1.9 2.7-.8 5.4-1.4 8-1.9Zm40.4 13.4c4.1 1.4 8.6 2.8 13.3 3.9v-8.2c-6 .2-12.2 1.1-18.7 2.7 1.8.5 3.6 1 5.4 1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0073BD",
    fillRule: "nonzero",
    d: "M556.7 235.6c1-.1 1.9-.2 2.8-.3-.3-.1-.7-.2-1-.3l-1.8.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0073BD",
    fillRule: "nonzero",
    d: "M597.4 243.2h-3c-2.7-.1-5.3-.3-7.9-.7-7.8-1.2-15.3-3.5-21.9-5.7-1.7-.6-3.4-1.1-5.1-1.5-.9.1-1.9.2-2.8.3-5.3 1.7-11 3.4-17 4.5-3.6.7-7.3 1.1-11 1.2h-3c-.4 0-.8 0-1.1-.1v3c0 .5.2.9.6 1.2.2.2.5.3.8.3.2 0 .4 0 .6-.2l1-.6c6.4-3.7 13-5.5 20.3-5.5 5.2 0 10.8 1 16.6 2.9 5.3 1.7 11.4 3.6 17.7 3.9h3.6c4.1-.2 8.2-1.3 12.5-3.1-.3 0-.6.1-.9.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006EB8",
    fillRule: "nonzero",
    d: "M559 234.8c-.1 0-.3.1-.4.1.3.1.7.2 1 .3.2 0 .4-.1.6-.1-.5-.1-.9-.2-1.2-.3Zm26 4.7h-1.5c-8.2-.3-16.2-2.2-23.4-4.3-.2 0-.4.1-.6.1l5.1 1.5c6.6 2.2 14.1 4.5 21.9 5.7 2.6.4 5.3.6 7.9.7h3.8c1-.5 2.1-1 3.2-1.5 1.1-.6 2.1-1.2 3.3-1.9l.8-.5c1-.6 2-1.5 2.2-3.4-6.7 1.9-13.8 3.5-21.2 3.7-.6-.1-1-.1-1.5-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006EB8",
    fillRule: "nonzero",
    d: "m559.5 235.2 5.1 1.5c6.6 2.2 14.1 4.5 21.9 5.7-7.8-1.2-15.3-3.5-21.9-5.7l-5.1-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006EB8",
    fillRule: "nonzero",
    d: "M560.1 235.2c-.2 0-.4.1-.6.1.2-.1.4-.1.6-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0066B1",
    fillRule: "nonzero",
    d: "M560.1 235.2c4.9-.7 9.6-1.9 14.1-3.2 1.5-.4 3-.9 4.4-1.4-6.3.6-12.9 2-19.7 4.2.4.1.8.2 1.2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0066B1",
    fillRule: "nonzero",
    d: "M585.4 230.3c-2.2 0-4.5.1-6.8.3-1.4.5-2.9.9-4.4 1.4-4.5 1.3-9.3 2.5-14.1 3.2 7.3 2.2 15.2 4.1 23.4 4.3h3c7.4-.2 14.6-1.8 21.2-3.7v-2.2c-1-.3-2-.5-3-.8-6.7-1.7-13.1-2.5-19.3-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0066B1",
    fillRule: "nonzero",
    d: "M560.1 235.2c4.9-.7 9.6-1.9 14.1-3.2-4.5 1.3-9.3 2.4-14.1 3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006BB6",
    fillRule: "nonzero",
    d: "M558.5 235c-7.2-1.9-14.2-2.9-20.7-2.9-2.4 0-4.9.1-7.4.4 4.7 1.3 9.6 2.4 14.6 3 1.7.2 3.4.3 5 .4h2.8c1.3 0 2.7-.1 4-.3.5-.2 1.1-.4 1.7-.6Zm-1.8.6 1.8-.6-1.8.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006BB6",
    fillRule: "nonzero",
    d: "M527.2 241.4h1.5c3.7-.1 7.4-.6 11-1.2 6-1.1 11.7-2.8 17-4.5-1.3.1-2.6.2-4 .3h-2.8c-1.7-.1-3.4-.2-5-.4-5-.6-9.9-1.7-14.6-3-1.9.2-3.8.5-5.7.8v8c.4 0 .8 0 1.1.1.6-.2 1-.1 1.5-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006BB6",
    fillRule: "nonzero",
    d: "M539.7 240.1c6-1.1 11.7-2.8 17-4.5-5.3 1.7-11 3.4-17 4.5Zm-9.4-7.6c4.7 1.3 9.6 2.4 14.6 3-5-.6-9.9-1.7-14.6-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0066B1",
    fillRule: "nonzero",
    d: "M530.3 232.5c2.5-.3 5-.4 7.4-.4 6.6 0 13.5 1 20.7 2.9.1 0 .3-.1.4-.1-1.8-.6-3.6-1.1-5.3-1.7-5.3-1.7-10.4-3-15.4-3.8-2.9 1-6 1.9-9.2 2.8.6.1 1 .2 1.4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0066B1",
    fillRule: "nonzero",
    d: "M529.1 232.2c-1.5.4-3 .8-4.5 1.1 1.9-.3 3.8-.6 5.7-.8l-1.2-.3Zm0 0 1.2.3-1.2-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005FAB",
    fillRule: "nonzero",
    d: "M559 234.8c6.8-2.2 13.4-3.6 19.7-4.2 1.1-.3 2.2-.7 3.2-1 2.4-.8 4.8-1.5 7.1-2.1-7.7-2.1-15.2-3.2-22.3-3.2-1.1 0-2.2 0-3.3.1-7.7.4-15.9 1.9-24.4 4.7-.3.1-.5.2-.8.3 5 .8 10.1 2 15.4 3.8 1.8.5 3.5 1.1 5.4 1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005FAB",
    fillRule: "nonzero",
    d: "M566.7 224.3c7.1 0 14.5 1.1 22.3 3.2-7.8-2.1-15.2-3.2-22.3-3.2Zm-28.5 5.1c5 .8 10.1 2 15.4 3.8-5.2-1.8-10.4-3.1-15.4-3.8Zm50.8-1.9c-2.4.6-4.7 1.3-7.1 2.1-1 .3-2.1.7-3.2 1 2.3-.2 4.6-.3 6.8-.3 6.1 0 12.6.8 19.3 2.5 1 .2 2 .5 3 .8v-.5c-4.7-1.1-9.1-2.6-13.3-3.9-1.9-.7-3.7-1.2-5.5-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005FAB",
    fillRule: "nonzero",
    d: "M607.7 233c-4.7-1.1-9.1-2.6-13.3-3.9 4.1 1.4 8.6 2.8 13.3 3.9Zm-18.7-5.5c1.8.5 3.6 1 5.4 1.6-1.8-.6-3.6-1.1-5.4-1.6Zm-3.6 2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.3 132.1c2.5-.3 5-.4 7.4-.4-2.4 0-4.9.2-7.4.4Zm19.6 3.3c-6.8-.2-13.4-1.6-19.6-3.3 6.2 1.8 12.9 3.1 19.6 3.3Zm-25.2-12.1c5.8-1.2 11.4-3 16.4-4.6-5 1.6-10.6 3.3-16.4 4.6Zm2.5 17.7h1.5-1.5Zm44.6-2.3c4.7 1.4 9.6 2.6 14.8 3.4-5.2-.8-10.1-2-14.8-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.6 132.9c1.9-.3 3.8-.6 5.7-.8-1.9.2-3.8.5-5.7.8Zm60.8-3c6.1 0 12.6.8 19.3 2.5-6.7-1.7-13.1-2.5-19.3-2.5Zm-22.3 6c-1.2-.4-2.4-.7-3.6-1.1 1.2.4 2.4.7 3.6 1.1Zm6.1-16.1c-6.9-.2-13.7-1.7-20-3.4 6.3 1.7 13.1 3.2 20 3.4Zm2.9 4.3c5.4.4 11.1 1.4 16.9 3 6.4-1.6 12.7-2.5 18.7-2.7-6 .2-12.2 1.1-18.7 2.7-5.8-1.6-11.5-2.6-16.9-3Zm-33.1 4.6c9.7-3.2 19-4.8 27.7-4.8-8.7 0-18 1.7-27.7 4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B5AD52",
    fillRule: "nonzero",
    d: "M544.7 115c1.5.5 2.9.9 4.5 1.3 1.6-.4 3.3-.7 4.9-1.1-2.1-.3-4.1-.4-6.1-.4-1.2.1-2.3.1-3.3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ADA23B",
    fillRule: "nonzero",
    d: "M549.1 116.3c0 .1 0 .1 0 0 0 .1 0 .1 0 0-1.5-.4-3-.9-4.5-1.3-6.3.5-12.1 2.3-17.8 5.6-.7.4-1.9 1.4-2.1 2.7 5.8-1.2 11.4-3 16.4-4.6 2.7-.9 5.4-1.7 8-2.4Zm58.5-.7c0-.4-.1-.9-.7-1.3-.2-.1-.4-.2-.7-.2-.3 0-.5.1-.8.2-.4.2-.7.4-1.1.7l-.7.4c-1.1.6-2.1 1.3-3.1 1.8-1.2.6-2.3 1.2-3.5 1.6 3.3 1.1 6.8 2.2 10.5 3.2l.1-6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ADA23B",
    fillRule: "nonzero",
    d: "M544.7 115c1.5.5 2.9.9 4.5 1.3-1.6-.4-3.1-.8-4.5-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ADA940",
    fillRule: "nonzero",
    d: "M569.2 119.8h2.3c-2.2-.6-4.4-1.3-6.4-2-3.8-1.2-7.5-2.1-11-2.6-1.6.3-3.2.7-4.9 1.1 6.2 1.8 13.1 3.3 20 3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D3B525",
    fillRule: "nonzero",
    d: "M538.2 129c-1-.2-2-.3-2.9-.4-2.9-.3-5.8-.5-8.5-.5h-2.1v2.3c1.5.5 2.9.9 4.5 1.4 3.1-.9 6.1-1.9 9-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8D9F38",
    fillRule: "nonzero",
    d: "M524.6 130.4v2.5c1.5-.4 3-.7 4.5-1.1-1.5-.5-3-.9-4.5-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A59F33",
    fillRule: "nonzero",
    d: "M569.2 119.8c-6.9-.2-13.7-1.7-20-3.4-2.6.6-5.3 1.4-8 2.3-5.1 1.7-10.6 3.4-16.4 4.6v4.8h2.1c2.8 0 5.6.2 8.5.5 1 .1 1.9.2 2.9.4.3-.1.5-.2.8-.3 9.7-3.2 19-4.8 27.7-4.8 1.8 0 3.6.1 5.4.2 5.4.4 11.1 1.4 16.9 3 6.4-1.6 12.7-2.5 18.7-2.7V122c-3.6-1-7.2-2.1-10.5-3.2-4.5 1.9-8.8 2.9-13.2 2.9h-1c-4-.1-7.9-.9-11.6-1.9h-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A59F33",
    fillRule: "nonzero",
    d: "M607.6 122c-3.6-1-7.2-2.1-10.5-3.2 3.4 1.1 6.9 2.2 10.5 3.2Zm-66.5-3.4c2.7-.9 5.3-1.6 8-2.3-2.6.7-5.3 1.5-8 2.3Zm-5.8 10c-2.9-.3-5.8-.5-8.5-.5h-2.1 2.1c2.8 0 5.6.1 8.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6A903E",
    fillRule: "nonzero",
    d: "M594.4 128.7c4.1 1.4 8.6 2.8 13.3 3.9v-8.2c-6 .2-12.2 1.1-18.7 2.7 1.8.5 3.6 1 5.4 1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#79A76E",
    fillRule: "nonzero",
    d: "M556.7 135.2c1-.1 1.9-.2 2.9-.3-.3-.1-.7-.2-1-.3-.7.2-1.3.4-1.9.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C9A6F",
    fillRule: "nonzero",
    d: "M596 142.8h-1.5c-2.7-.1-5.3-.3-7.9-.7-5.1-.8-10.1-2-14.8-3.4-2.5-.7-4.9-1.5-7.2-2.3-.5-.2-1-.3-1.6-.5-1.2-.4-2.4-.7-3.6-1.1-.9.1-1.9.2-2.9.3-8.4 2.7-18 5.5-28 5.8h-3c-.4 0-.8 0-1.1-.1v3c0 .5.2.9.6 1.2.2.2.5.3.8.3.2 0 .4 0 .6-.2l1-.6c6.4-3.7 13-5.5 20.3-5.5 5.2 0 10.8 1 16.6 2.9 5.4 1.8 11.8 3.7 18.4 3.9h1.1c4.7 0 9.4-1.1 14.3-3.2h-.8c-.4.2-.9.2-1.3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6CA14B",
    fillRule: "nonzero",
    d: "M558.6 134.6c-.1 0-.1 0 0 0 .3.1.6.2 1 .3.2 0 .4-.1.6-.1-.4-.1-.7-.2-1.1-.3-.3 0-.4 0-.5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#36964F",
    fillRule: "nonzero",
    d: "M585 139.2h-1.5c-8.2-.3-16.2-2.2-23.4-4.3-.2 0-.4.1-.6.1 1.2.3 2.4.7 3.6 1.1.5.2 1 .3 1.6.5 2.3.8 4.7 1.5 7.2 2.3 4.7 1.4 9.6 2.6 14.8 3.4 2.6.4 5.3.6 7.9.7h3.8c1-.5 2.1-1 3.2-1.5 1.1-.6 2.1-1.2 3.3-1.9l.8-.5c1-.6 2-1.5 2.2-3.4-6.7 1.9-13.8 3.5-21.2 3.7-.8-.3-1.2-.3-1.7-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#36964F",
    fillRule: "nonzero",
    d: "M571.8 138.7c-2.5-.7-4.9-1.5-7.2-2.3-.5-.2-1-.3-1.6-.5.5.2 1 .3 1.6.5 2.3.8 4.7 1.5 7.2 2.3Zm24.2 4.1h-1.5c-2.7-.1-5.3-.3-7.9-.7 2.6.4 5.3.6 7.9.7h1.5Zm0 0h2.3-2.3Zm-36.5-7.9c.2 0 .4-.1.6-.1-.2 0-.4 0-.6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4E944D",
    fillRule: "nonzero",
    d: "M560.1 134.8c6.5-.9 12.8-2.7 18.6-4.6-6.3.6-12.9 2-19.7 4.2.3.2.7.3 1.1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#148C4F",
    fillRule: "nonzero",
    d: "M585.4 129.9c-2.2 0-4.5.1-6.8.3-5.8 1.8-12 3.6-18.6 4.6 7.3 2.2 15.2 4.1 23.4 4.3h3c7.4-.2 14.6-1.8 21.2-3.7v-2.2c-1-.3-2-.5-3-.8-6.6-1.7-13-2.5-19.2-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7E904A",
    fillRule: "nonzero",
    d: "M537.8 131.7c-2.4 0-4.9.1-7.4.4 6.2 1.7 12.9 3.1 19.6 3.3h2.8c1.3 0 2.7-.1 4-.3l1.8-.6c-7.3-1.8-14.3-2.8-20.8-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4E854F",
    fillRule: "nonzero",
    d: "M527.2 141h1.5c9.9-.3 19.6-3 28-5.8-1.3.1-2.6.2-4 .3h-2.8c-6.8-.2-13.4-1.6-19.6-3.3-1.9.2-3.8.5-5.7.8v8c.4 0 .8 0 1.1.1.6-.1 1-.1 1.5-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4E854F",
    fillRule: "nonzero",
    d: "M524.6 140.9c.4 0 .8 0 1.1.1-.3-.1-.7-.1-1.1-.1Zm32.1-5.7c-8.4 2.7-18 5.5-28 5.8 9.9-.4 19.6-3.1 28-5.8Zm-29.5 5.8h-1.5 1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#718C3D",
    fillRule: "nonzero",
    d: "M530.3 132.1c2.5-.3 5-.4 7.4-.4 6.6 0 13.5 1 20.7 2.9.1 0 .3-.1.4-.1-1.8-.6-3.6-1.1-5.3-1.7-5.3-1.7-10.4-3-15.4-3.8-2.9 1-6 1.9-9.2 2.8.6.1 1 .2 1.4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#468341",
    fillRule: "nonzero",
    d: "M529.1 131.8c-1.5.4-3 .8-4.5 1.1 1.9-.3 3.8-.6 5.7-.8l-1.2-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#58813F",
    fillRule: "nonzero",
    d: "M559 134.4c6.8-2.2 13.4-3.6 19.7-4.2 1.1-.3 2.2-.7 3.2-1 2.4-.8 4.8-1.5 7.1-2.1-5.8-1.6-11.5-2.6-16.9-3-1.8-.1-3.6-.2-5.4-.2-8.7 0-18 1.6-27.7 4.8-.3.1-.5.2-.8.3 5 .8 10.1 2 15.4 3.8 1.8.5 3.5 1.1 5.4 1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#58813F",
    fillRule: "nonzero",
    d: "M578.6 130.2c-6.3.6-12.9 2-19.7 4.2 6.8-2.2 13.4-3.6 19.7-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#58813F",
    fillRule: "nonzero",
    d: "M559 134.4c-1.8-.6-3.6-1.1-5.3-1.7 1.7.6 3.4 1.2 5.3 1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#327B42",
    fillRule: "nonzero",
    d: "M589 127.1c-2.4.6-4.7 1.3-7.1 2.1-1 .3-2.1.7-3.2 1 2.3-.2 4.6-.3 6.8-.3 6.1 0 12.6.8 19.3 2.5 1 .2 2 .5 3 .8v-.5c-4.7-1.1-9.1-2.6-13.3-3.9-1.9-.7-3.7-1.2-5.5-1.7Zm-3.6 2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.6 200.3c-.7-.2-1.4-.5-2.2-.7.7.3 1.4.5 2.2.7 5.1-1.6 10.1-2.9 14.9-3.6-4.9.8-9.8 2-14.9 3.6Zm-2.3.8c-8.4 2.7-18 5.5-28 5.8 9.9-.4 19.6-3.1 28-5.8Zm39.3 7.6h1.5c1.1 0 2.2-.1 3.3-.2-1.1.1-2.2.2-3.3.2h-1.5Zm-72-9.8c.2 0 .4-.1.6-.1-.2 0-.4.1-.6.1Zm72 9.8h-1.5c-10.7-.3-21-3.5-29.9-6.4 8.8 2.9 19.2 6.1 29.9 6.4h1.5Zm-69.2-14.8c3.7 0 7.5.3 11.5.9-4-.6-7.8-.9-11.5-.9Zm-2-4.8c5.2-1.1 10.2-2.6 14.8-4.1-4.7 1.5-9.7 3-14.8 4.1Zm64.2 3.9-4.2 1.2c1.4-.5 2.8-.9 4.2-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595 194.6c-1.8-.6-3.6-1.1-5.4-1.6-5.8-1.6-11.5-2.6-16.9-3 5.4.4 11.1 1.4 16.9 3 1.8.5 3.6 1 5.4 1.6Zm-56.1.3c5 .8 10.1 2 15.4 3.8-5.3-1.8-10.5-3.1-15.4-3.8Zm68.8 4c-6.4-1.7-12.6-2.8-18.5-3 5.9.2 12.1 1.2 18.5 3Zm-.1-8.6c-5 .2-10.1.9-15.4 2 5.3-1.1 10.5-1.8 15.4-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5777BA",
    fillRule: "nonzero",
    d: "M607 181.5c-.2-.1-.4-.2-.7-.2-.3 0-.5.1-.8.2-.4.2-.7.4-1.1.7l-.7.4c-1.1.6-2.1 1.3-3.1 1.8-.1 0-.1.1-.2.1 2.4-.4 4.8-1 7.2-1.6v-.1c0-.4 0-.9-.6-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2261AC",
    fillRule: "nonzero",
    d: "M599.2 185.2c2.7.9 5.6 1.8 8.5 2.5v-4.8c-2.3.6-4.7 1.2-7.2 1.6-.5.2-.9.5-1.3.7Zm-57.5-.7c2.8-.9 5.5-1.7 8.3-2.4-.7 0-1.4-.1-2.1-.1-7.5 0-14.4 1.9-21.1 5.7-.4.2-1 .7-1.5 1.3 5.2-1.1 10.2-2.6 14.8-4.1.6 0 1.1-.2 1.6-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4360A9",
    fillRule: "nonzero",
    d: "M524.6 198.9c.2 0 .4-.1.6-.1-.2 0-.4.1-.6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3A57A4",
    fillRule: "nonzero",
    d: "M538.9 194.9c-3.9-.6-7.8-.9-11.5-.9-.9 0-1.8 0-2.7.1v2.1c1.7.5 3.3 1 5.1 1.5 3.1-.9 6.1-1.9 9.1-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2555A3",
    fillRule: "nonzero",
    d: "m529.7 197.7-5.1-1.5v2.8c.2 0 .4-.1.6-.1 1.5-.5 3-.8 4.5-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3153A1",
    fillRule: "nonzero",
    d: "M584 188.9h-1c-6.4-.2-12.6-2.1-17.9-3.9-5.2-1.7-10.2-2.7-15-2.9-2.7.7-5.5 1.4-8.3 2.4-.5.2-1.1.4-1.6.5-4.6 1.5-9.6 3-14.8 4.1-.4.5-.7 1.1-.7 1.7v3.2c.9 0 1.8-.1 2.7-.1 3.7 0 7.5.3 11.5.9.3-.1.5-.2.8-.3 9.7-3.2 19-4.8 27.7-4.8 1.8 0 3.6.1 5.4.2 5.4.4 11.1 1.4 16.9 3l2.7-.6c5.3-1.2 10.4-1.9 15.4-2v-2.6c-2.9-.8-5.8-1.7-8.5-2.5-5.3 2.5-10.3 3.7-15.3 3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3153A1",
    fillRule: "nonzero",
    d: "M599.2 185.2c2.7.9 5.6 1.8 8.5 2.5-3-.8-5.8-1.6-8.5-2.5Zm-49.2-3c-2.7.7-5.5 1.4-8.3 2.4 2.8-1 5.6-1.8 8.3-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C52A0",
    fillRule: "nonzero",
    d: "M589.6 193c1.8.5 3.6 1 5.4 1.6 4 1.3 8.2 2.6 12.7 3.8v-8.1c-5 .2-10.1.9-15.4 2-.9.2-1.8.5-2.7.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F78BD",
    fillRule: "nonzero",
    d: "M557.3 201.1c1-.1 1.9-.2 2.8-.3-.3-.1-.7-.2-1-.3l-1.8.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0074BB",
    fillRule: "nonzero",
    d: "M596.6 208.7h-1.5c-10.7-.3-21-3.5-29.9-6.4-1.7-.6-3.4-1.1-5.1-1.5-.9.1-1.9.2-2.8.3-8.4 2.7-18 5.5-28 5.8h-3c-.6 0-1.2-.1-1.8-.1v4.4c0 .5.2.9.6 1.2.2.2.5.3.8.3.2 0 .4 0 .6-.2l1-.6c6.4-3.7 13-5.5 20.3-5.5 5.2 0 10.8 1 16.6 2.9 5.4 1.8 11.8 3.7 18.4 3.9h1.1c5.7 0 11.4-1.5 17.4-4.7-1.1.1-2.2.2-3.3.2h-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006AB3",
    fillRule: "nonzero",
    d: "M560.7 200.7c-.4-.1-.7-.2-1.1-.3-.1 0-.3.1-.4.1.3.1.7.2 1 .3.1-.1.3-.1.5-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006AB3",
    fillRule: "nonzero",
    d: "M559.1 200.5c.3.1.7.2 1 .3-.3-.2-.7-.3-1-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0068B3",
    fillRule: "nonzero",
    d: "M585.6 205h-1.5c-2-.1-4.1-.2-6.1-.5-6-.7-11.9-2.2-17.3-3.9-.2 0-.4.1-.6.1l5.1 1.5c8.8 2.9 19.2 6.1 29.9 6.4h3c1.1 0 2.2-.1 3.3-.2 1.1-.6 2.1-1.2 3.3-1.9l.8-.5c1.1-.7 2.2-1.7 2.2-3.9v-.6c-6.5 1.8-13.5 3.3-20.6 3.5h-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0068B3",
    fillRule: "nonzero",
    d: "M560.1 200.7c.2 0 .4-.1.6-.1-.2.1-.4.1-.6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0065AF",
    fillRule: "nonzero",
    d: "M559.6 200.3c.4.1.7.2 1.1.3.8-.1 1.6-.2 2.4-.4 5.6-1 11.1-2.6 16.1-4.2l-4.8.6c-4.8.9-9.7 2.1-14.8 3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0063AF",
    fillRule: "nonzero",
    d: "M586 195.8c-2.2 0-4.5.1-6.8.3-5 1.6-10.5 3.2-16.1 4.2-.8.1-1.6.3-2.4.4 5.4 1.6 11.3 3.1 17.3 3.9 2 .2 4.1.4 6.1.5h3c7.2-.2 14.1-1.7 20.6-3.5V199c-6.4-1.7-12.6-2.8-18.5-3-1.1-.2-2.1-.2-3.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0063AF",
    fillRule: "nonzero",
    d: "M578 204.5c-6-.7-11.9-2.2-17.3-3.9 5.4 1.7 11.3 3.2 17.3 3.9Zm1.2-8.4c-5 1.6-10.5 3.2-16.1 4.2 5.6-1 11.1-2.6 16.1-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3A57A4",
    fillRule: "nonzero",
    d: "M538.4 197.6c-2.4 0-4.9.1-7.4.4 6.2 1.7 12.9 3.1 19.6 3.3h2.8c1.3 0 2.7-.1 4-.3l1.8-.6c-7.3-1.8-14.3-2.8-20.8-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2555A3",
    fillRule: "nonzero",
    d: "M527.8 206.9h1.5c9.9-.3 19.6-3 28-5.8-1.3.1-2.6.2-4 .3h-2.8c-6.8-.2-13.4-1.6-19.6-3.3-1.9.2-3.8.5-5.7.8-.2 0-.4.1-.6.1v7.8c.6 0 1.2.1 1.8.1.5-.1 1 0 1.4 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#234F9E",
    fillRule: "nonzero",
    d: "M530.9 198c2.5-.3 5-.4 7.4-.4 6.6 0 13.5 1 20.7 2.9.1 0 .3-.1.4-.1-.7-.2-1.4-.5-2.2-.7-1.1-.3-2.1-.7-3.2-1-5.3-1.7-10.4-3-15.4-3.8-2.9 1-6 1.9-9.2 2.8.7.1 1.1.2 1.5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#164F9E",
    fillRule: "nonzero",
    d: "M525.2 198.8c1.9-.3 3.8-.6 5.7-.8l-1.2-.3c-1.5.4-3 .7-4.5 1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F4C9C",
    fillRule: "nonzero",
    d: "M557.4 199.6c.7.2 1.4.5 2.2.7 5.1-1.7 10.1-2.9 14.9-3.6 1.6-.3 3.2-.5 4.8-.6 1.1-.3 2.2-.7 3.2-1 1-.3 1.9-.6 2.9-.9l4.2-1.2c-5.8-1.6-11.5-2.6-16.9-3-1.8-.1-3.6-.2-5.4-.2-8.7 0-18 1.6-27.7 4.8-.3.1-.5.2-.8.3 5 .8 10.1 2 15.4 3.8 1.1.3 2.1.6 3.2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F4C9C",
    fillRule: "nonzero",
    d: "M557.4 199.6c-1.1-.3-2.1-.7-3.2-1 1.1.4 2.1.7 3.2 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#144C9C",
    fillRule: "nonzero",
    d: "m589.6 193-4.2 1.2c-1 .3-1.9.6-2.9.9-1 .3-2.1.7-3.2 1 2.3-.2 4.6-.3 6.8-.3 1 0 2.1 0 3.1.1 5.9.3 12.1 1.3 18.5 3v-.5c-4.4-1.1-8.7-2.5-12.7-3.8-1.8-.6-3.6-1.1-5.4-1.6Zm-10.4 3.1c1.1-.3 2.2-.7 3.2-1 1-.3 1.9-.6 2.9-.9-1 .3-1.9.6-2.9.9-1 .3-2.1.7-3.2 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M108.7 223.7h10.2v3.5h-6.6v5.8h4.9v3.2h-4.9v5.9h6.6v3.5h-10.2v-21.9m13.1 0h3.5l5.1 13v-13h3.7v21.9h-3.5l-5.1-12.8v12.8h-3.7v-21.9m21.6 0h6c3.6 0 6.1 2.3 6.1 6.7v8.4c0 4.4-2.5 6.7-6.1 6.7h-6v-21.8m5.5 18.4c1.6 0 2.9-.7 2.9-3.8v-7.6c0-2.2-.8-3.5-2.9-3.5H147v14.9h1.9Zm9.7-18.4h10.2v3.5h-6.6v5.8h4.9v3.2h-4.9v5.9h6.6v3.5h-10.2v-21.9m13.1 0h3.7v18.4h5.9v3.5h-9.6v-21.9m21.3 0h3.9l5.2 21.9h-3.7l-.9-4.3h-5.1l-1 4.3h-3.7l5.3-21.9m3.9 14.5-1.9-9.1-1.9 9.1h3.8Zm4.6-14.5h3.7l3 16 3.1-16h3.7l-4.8 21.9h-3.9l-4.8-21.9m21.1 0h3.6v18.4h6v3.5h-9.6v-21.9m15.6 0h3.9l5.2 21.9h-3.7l-.9-4.3h-5.1l-1 4.3h-3.7l5.3-21.9m3.8 14.5-1.9-9.1-1.9 9.1h3.8Zm7.2-14.5h3.6v9.2h1.3l3.5-9.2h4.1l-4.5 10.8 4.5 11.1h-4.1l-3.5-9.5h-1.3v9.5h-3.6v-21.9m14.9 0h10.2v3.5h-6.6v5.8h4.9v3.2h-4.9v5.9h6.6v3.5h-10.2v-21.9m17.3 0h3.7l3 16 3-16h3.7l-4.8 21.9h-3.8l-4.8-21.9m18.1 0h3.9l5.2 21.9h-3.7l-.9-4.3h-5.1l-1 4.3h-3.7l5.3-21.9m-2-3.4c0-.9.7-1.6 1.6-1.6.9 0 1.6.7 1.6 1.6 0 .9-.7 1.6-1.6 1.6-.9 0-1.6-.7-1.6-1.6Zm5.9 17.9-1.9-9.1-1.9 9.1h3.8Zm-1.1-17.9c0-.9.7-1.6 1.6-1.6.9 0 1.6.7 1.6 1.6 0 .9-.7 1.6-1.6 1.6-.9.1-1.6-.7-1.6-1.6Zm8.4 3.4h3.4l5.1 13v-13h3.7v21.9h-3.5l-5.1-12.8v12.8h-3.6v-21.9m15.7 0h10.2v3.5h-6.5v5.8h4.9v3.2h-4.9v5.9h6.5v3.5h-10.2v-21.9m13.2 0h5.8c3.6 0 6.1 2.4 6.1 6.7v2.9c0 2.9-1.2 4.8-3.1 5.7l3.1 6.7h-4l-2.5-5.8h-1.7v5.8h-3.7v-22m5.4 12.7c1.5 0 2.9-.6 2.9-3.2v-2.9c0-2.5-1.4-3.1-2.9-3.1h-1.7v9.1l1.7.1Zm9.6-12.7h3.4l5.1 13v-13h3.7v21.9h-3.4l-5.2-12.8v12.8h-3.6v-21.9m21.1 15.9v-9.9c0-3.7 2.5-6.3 6-6.3s6 2.5 6.1 6.2h-3.6c0-1.9-1-2.6-2.4-2.6s-2.4.7-2.4 3v9.8c0 1.9 1.1 2.7 2.4 2.7 1.3 0 2.5-.7 2.5-2.7v-1.7h-2.4v-3.2h6.1v4.8c0 3.7-2.5 6.3-6.1 6.3-3.7-.1-6.2-2.7-6.2-6.4m15.1-15.9h5.8c3.6 0 6.1 2.4 6.1 6.7v2.9c0 2.9-1.2 4.8-3.1 5.7l3.1 6.7h-4l-2.5-5.8h-1.7v5.8h-3.7v-22m5.4 12.7c1.5 0 2.9-.6 2.9-3.2v-2.9c0-2.5-1.4-3.1-2.9-3.1h-1.7v9.1l1.7.1Zm13.3-12.7h3.9l5.2 21.9h-3.7l-1-4.3h-5.1l-1 4.3h-3.7l5.4-21.9m3.8 14.5-1.9-9.1-1.9 9.1h3.8Zm7.2-14.5h3.4l5.1 13v-13h3.7v21.9h-3.4l-5.2-12.8v12.8h-3.6v-21.9m15.8 0h6c3.6 0 6.1 2.3 6.1 6.7v8.4c0 4.4-2.5 6.7-6.1 6.7h-6v-21.8m5.6 18.4c1.6 0 2.9-.7 2.9-3.8v-7.6c0-2.2-.8-3.5-2.9-3.5H440v14.9h1.9Zm17.8-14.9H456v-3.5h11.1v3.5h-3.8v18.4h-3.6v-18.4m8.9 12.4v-9.8c0-3.7 2.5-6.3 6.1-6.3 3.6 0 6.1 2.6 6.1 6.3v9.8c0 3.7-2.5 6.3-6.1 6.3-3.6 0-6.1-2.6-6.1-6.3m8.5.1v-10.1c0-2-1.1-2.7-2.5-2.7-1.2 0-2.4.7-2.4 2.7v10.1c0 2 1.2 2.7 2.4 2.7s2.5-.7 2.5-2.7Zm6.6-.1v-15.9h3.6v16c0 2 1.2 2.6 2.5 2.6 1.2 0 2.4-.7 2.4-2.6v-16h3.6v15.9c0 3.8-2.5 6.3-6.1 6.3-3.6 0-6-2.5-6-6.3m15.4-15.9h5.8c3.6 0 6.1 2.4 6.1 6.7v2.9c0 2.9-1.2 4.8-3.1 5.7l3.1 6.7h-4l-2.5-5.8h-1.7v5.8h-3.7v-22m5.4 12.7c1.5 0 2.9-.6 2.9-3.2v-2.9c0-2.5-1.4-3.1-2.9-3.1h-1.7v9.1l1.7.1Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(653.3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#007EC6",
    fillRule: "nonzero",
    d: "M174.1 348.3c96.1 0 174-78 174-174s-78-174-174-174-174 78-174 174 77.9 174 174 174",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(653.3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M219.6 202.5c2.5-1 4.2-3.7 4.2-7.4 0-5.4-4.5-9.7-10.9-9.7s-11.1 4.7-11.1 11.1h8.4c0-2.5 1.5-3.2 2.7-3.2 1.2 0 2.7.7 2.7 2.7s-1.2 3.2-3.7 3.2h-2.7v7.4h3.2c3 0 3.7.7 3.7 2.7 0 2.2-1.7 2.7-3 2.7-1.5 0-3-.5-3-3.2h-8.4c0 6.9 4.7 11.6 11.4 11.6s11.4-4.5 11.4-10.9c-.2-4-2.7-6.2-4.9-7m-22 9.2h-13.1c0-4.2 13.6-5.2 13.6-15.6 0-6.2-4.5-10.4-11.1-10.4-6.4 0-10.9 4.5-10.9 11.1h8.4c0-2.5 1.2-3.2 2.7-3.2 1.5 0 2.7.7 2.7 2.7 0 6.2-13.6 5.7-13.6 17.1v6.4h21.8v-8.2h-.5v.1Zm-36.4-17.8c1.2 0 2.7.2 2.7 3.2v12.1c0 2.7-1.5 3.2-2.7 3.2-1.2 0-2.7-.2-2.7-3.2v-12.1c-.3-3 1.2-3.2 2.7-3.2m0 26.4c6.4 0 11.1-4.7 11.1-11.6v-11.6c0-6.9-4.7-11.6-11.1-11.6-6.7 0-11.1 4.7-11.1 11.6v11.6c-.3 6.9 4.4 11.6 11.1 11.6m-15.6-8.6h-13.1c0-4.2 13.6-5.2 13.6-15.6 0-6.2-4.5-10.4-11.1-10.4-6.4 0-10.9 4.5-10.9 11.1h8.4c0-2.5 1.2-3.2 2.7-3.2 1.5 0 2.7.7 2.7 2.7 0 6.2-13.6 5.7-13.6 17.1v6.4h21.8v-8.2h-.5v.1Z",
    mask: "url(#f)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(653.3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M246.8 151c0-1.7 1-2.2 2-2.2s2 .5 2 2.2v2h-4.2v-2h.2Zm4 9.7v.7c0 1.5-1.2 1.7-2 1.7-1 0-2-.5-2-2.2v-2.7h12.1v-5.9c0-6.4-3.7-10.2-10.2-10.2-6.4 0-10.2 4-10.2 10.6v6.4c0 6.4 3.7 10.4 10.2 10.4 6.4 0 10.2-4 10.2-8.7v-.2h-8.1v.1Zm-27.5-9.7c0-1.7 1-2.2 2-2.2s2 .5 2 2.2v2h-4.2v-2h.2Zm4.2 9.7v.7c0 1.5-1.2 1.7-2 1.7-1 0-2-.5-2-2.2v-2.7h12.2v-5.9c0-6.4-3.7-10.2-10.2-10.2-6.4 0-10.2 4-10.2 10.6v6.4c0 6.4 3.7 10.4 10.2 10.4 6.4 0 10.2-4 10.2-8.7v-.2h-8.2v.1Zm-27.9-8.9c0-1.7 1.2-2.2 2-2.2 1 0 2 .5 2 2.2v17.3h8.2v-17.6c0-6.9-3-9.2-7.2-9.2-3.7 0-5.4 2.7-5.4 2.7v-2.2h-7.4v26.7h7.9l-.1-17.7Zm-12.4-16.6c0-2.7-2.2-4.7-4.7-4.7-2.7 0-4.7 2.2-4.7 4.7 0 2.7 2.2 4.7 4.7 4.7 2.4 0 4.7-2 4.7-4.7m-.8 7.4h-7.9v26.7h7.9v-26.7Zm-36.1 9.2c0-1.7 1-2.2 1.7-2.2 1 0 1.7.5 1.7 2.2v17.3h8.2v-17.3c0-1.7 1-2.2 1.7-2.2 1 0 1.7.5 1.7 2.2v17.3h8.2v-17.6c0-6.9-2.7-9.2-6.9-9.2-3.5 0-5.2 2-5.9 3-1.2-2.2-3.2-3-5.9-3-3.7 0-5 2.7-5 2.7v-2.2h-7.4v26.7h7.9v-17.7Zm-22.3-2.5c1 0 2 .5 2 2.2v8.7c0 1.7-1.2 2.2-2 2.2-1 0-2-.5-2-2.2v-8.7c0-1.7 1-2.2 2-2.2m0 20.3c6.2 0 10.2-4 10.2-10.6v-6.4c0-6.2-3.7-10.4-10.2-10.4-6.4 0-10.2 4-10.2 10.4v6.4c.1 6.6 3.8 10.6 10.2 10.6m-14.8-33.9h-8.5v14.9l-6.2-14.9h-7.9v33.4H99v-14.9l6.2 14.9h7.9l.1-33.4Z",
    mask: "url(#h)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(653.3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DACF4B",
    fillRule: "nonzero",
    d: "M73 104c0-.7-.7-1-1.5-1.2l-12.4-1.7-5.4-11.2c-.2-.5-.7-1-1.2-1s-1 .5-1.2 1L45.9 101l-12.4 1.7c-.5 0-1.5.5-1.5 1.2 0 .5.2.7.5 1.2l8.9 8.7-2.2 12.4v.5c0 .7.2 1.2 1 1.2.2 0 .7 0 1-.2l11.1-5.7 11.1 5.7c.2.2.7.2 1 .2.7 0 1-.5 1-1.2v-.5l-2.2-12.4 8.9-8.7c.7-.4.9-.6.9-1.1",
    mask: "url(#j)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(653.3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DACF4B",
    fillRule: "nonzero",
    d: "M318.6 104c0-.7-.7-1-1.5-1.2l-12.4-1.7-5.4-11.1c-.2-.5-.7-1-1.2-1s-1 .5-1.2 1l-5.4 11.1-12.4 1.7c-.5 0-1.5.5-1.5 1.2 0 .5.2.7.5 1.2l8.9 8.7-2.2 12.4v.5c0 .7.2 1.2 1 1.2.2 0 .7 0 1-.2l11.1-5.7 11.1 5.7c.2.2.7.2 1 .2.7 0 1-.5 1-1.2v-.5l-2.2-12.4 8.9-8.7c.7-.5.9-.7.9-1.2",
    mask: "url(#l)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(653.3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "n",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DACF4B",
    fillRule: "nonzero",
    d: "M210.4 102.2c0-7.7-6.4-14.1-14.1-14.1-2.2 0-4.2.5-5.9 1.5L182 77c-.5-.5-1-1-1.7-1h-8.2c-1 0-2 1-2 2s1 2 2 2h6.9l2.7 4h-13.6v-4H156c-1 0-2 1-2 2s1 2 2 2h7.2l-4.2 5.7c-2-1-4.2-1.7-6.7-1.7-7.9 0-14.1 6.4-14.1 14.1 0 7.9 6.4 14.1 14.1 14.1 7.2 0 13.1-5.2 14.1-12.1h6.2c.7 0 1.2-.2 1.7-.7l11.1-14.9 2 3.2c-3 2.5-4.7 6.4-4.7 10.4 0 7.9 6.4 14.1 14.1 14.1 7.7-.1 13.6-6 13.6-14m-3.9 0c0 5.4-4.5 10.2-10.2 10.2-5.4 0-10.2-4.5-10.2-10.2 0-2.7 1.2-5.2 3-7.2l5.4 8.2c.5.5 1 1 1.7 1 .5 0 .7 0 1.2-.2 1-.5 1.2-2 .5-2.7l-5.4-8.2c1.2-.5 2.5-.7 3.7-.7 5.6-.3 10.3 4.4 10.3 9.8m-35.4-1.9h-5.2c-.5-3.2-2-5.9-4-7.9l3.2-4.2h15.1l-9.1 12.1Zm-15.1 0 3.5-4.7c1.2 1.2 2 3 2.5 4.7h-6Zm5.7 3.9c-1 4.7-5 8.2-9.9 8.2-5.4 0-10.2-4.5-10.2-10.2 0-5.4 4.5-10.2 10.2-10.2 1.5 0 3 .2 4.2 1l-5.9 7.9c-1 1.2 0 3.2 1.7 3.2 0 .1 9.9.1 9.9.1Z",
    mask: "url(#n)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(653.3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "p",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#o"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "m260.5 86.2 10.6-13.4c4.2-5.4 4-10.4-.2-13.9-3.2-2.7-6.7-2.2-8.4-1.5l2.5-3-3.5-2.7L244.1 73l3.5 3 10.1-12.6c3.2-4 5.9-5 9.2-2.2 3.5 2.7 2.7 5.9 0 9.4l-10.4 12.9 4 2.7Zm-29.3-24.3c-3.5-1.7-4-5-1.7-9.4l2.5-5c2.2-4.5 5.2-5.7 8.4-4.2s4 4.7 2 9.2l-2.5 5.2c-2.5 4.4-5.4 5.9-8.7 4.2m-2.9 2.7c3.7 2 7.2.7 8.7-.5l-1.7 3.5 4 2 12.1-24.5-4-2-1.7 3.5c0-2-1-5.2-4.7-7.2-4.7-2.2-9.7-.7-12.6 5.7l-3 6.2c-3.6 5.9-2.1 10.8 2.9 13.3M205 37.1c1-4 3.7-5.2 7.2-4.5 3.5 1 5 3.5 4 7.7l-.5 1.7-11.1-3 .4-1.9Zm15.6 5c1.7-6.4-1-11.4-7.2-12.9-6.4-1.7-11.1 1.2-12.9 7.9l-1.7 6.4c-1.7 6.4.7 11.4 7.2 13.1 6.2 1.7 11.1-1.2 12.4-6.2v-.2l-4.5-1.2v.5c-.7 3-3.7 4.5-6.9 3.5-3.2-.7-5-3.7-4-7.4l.7-3 15.6 4.2 1.3-4.7ZM181.5 28c3.7.2 5.7 3 5.4 7.7l-.2 5.4c-.2 5-2.2 7.4-6.2 7.2-3.7-.2-5.7-2.7-5.4-7.7l.2-5.7c.2-4.7 2.5-7.2 6.2-6.9m1.5-3.7c-4.2-.2-6.7 2.2-7.7 4l.2-4-4.2-.2-1.5 36.9 4.5.2.5-12.9c.7 1.7 3 4 7.2 4.2 5.4.2 9.2-3.5 9.4-10.4l.2-5.2c.3-8.2-2.7-12.4-8.6-12.6M150.5 30c3.5-.5 5.9 1.2 6.7 5.2l1.2 7.4c.7 4-1.2 6.4-4.7 7.2-3.5.5-6.2-1.2-6.7-5.2l-1.2-7.4c-.7-4 1.3-6.5 4.7-7.2m4 23.7c6.4-1 9.4-5.9 8.4-12.4l-1-6.4c-1-6.4-5.7-9.9-11.9-8.9-6.4 1-9.4 5.9-8.4 12.4l1 6.4c1 6.7 5.2 10.2 11.9 8.9m-22-24c-3.7 1.2-5.2 5-5.2 7.2l-1.5-4.7-4.2 1.2 8.4 26.2 4.2-1.5-5-15.1c-1.5-4.7.2-7.9 4.5-9.2l.5-.2-1.5-4.2-.2.3ZM93.3 47l8.2 15.6c3 5.4 8.4 7.4 14.1 4.2 5.4-3 7.2-8.4 4.2-14.1l-8.1-15.6-4 2.2 8.4 16.1c1.7 3.2.2 6.2-2.5 7.7s-5.9 1-7.7-2.2l-8.4-16.1-4.2 2.2ZM82 71.3l7.9-6.7-2.7-3.2-7.9 6.7-6.7-7.9L83.5 51l-3-3.5-14.6 12.4 22.3 26.2 14.6-12.4-3-3.5-10.9 9.2-6.9-8.1Z",
    mask: "url(#p)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(653.3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "r",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M287.7 142.4c1 3.7 4.2 5.4 6.7 5.4l-4.7 1.2 1 4 26-6.4-1-4.2-15.1 3.7c-4.7 1.2-7.7-.7-8.7-5.2v-.5l-4.2 1v1Zm28.2 24c.2 3.7-2 5.7-6.9 6.2l-5.4.5c-4.7.5-7.4-1.2-7.7-5-.2-3.5 2-5.7 6.4-6.2l5.7-.5c4.7-.2 7.4 1.5 7.9 5m3.7 1.2c-.2-4-3-6.2-4.7-6.9l3.7-.2-.2-4.2-26.5 2.5.2 4.2 3.7-.2c-1.7 1-3.7 3.5-3.5 7.7.5 5.2 4.2 8.2 11.1 7.7l6.7-.5c6.6-1.2 10-4.9 9.5-10.1m-19.3 30c-4-.5-5.7-3-5.2-6.2.5-3.5 2.5-5.4 6.9-5l1.7.2-1.2 11.1-2.2-.1Zm2.5-15.4c-6.4-.7-10.6 2.5-11.4 8.7-.7 6.4 3 10.4 9.4 11.1l6.4.7c6.4.7 10.9-2.5 11.6-8.9.7-6.2-3-10.4-7.7-10.9h-.2l-.5 4.5h.5c3 .2 4.7 2.7 4.2 6.2-.2 3.2-2.7 5.4-6.4 5l-3-.2 1.7-15.6-4.6-.6Zm-25.3 38.9 23.3-4 11.6 3.5 1.2-4.5-11.6-3.5c-5.7-5.4-11.6-10.9-17.3-16.1l-1.5 4.7 13.6 12.1L279 216l-1.5 5.1Zm-.2 30.9c-3.2-2.2-3.7-5.2-1.7-7.9 2-3 4.7-3.7 8.4-1.2l1.5 1-6.2 9.4-2-1.3Zm9.2-12.6c-5.4-3.7-10.6-2.5-14.1 2.7s-2.2 10.6 3.2 14.1l5.4 3.5c5.4 3.5 10.9 2.7 14.4-2.7 3.5-5.2 2.2-10.6-2-13.4h-.2l-2.5 3.7.2.2c2.5 1.7 3 4.7 1 7.4-1.7 2.7-5 3.5-7.9 1.5l-2.5-1.7 8.7-13.1-3.7-2.2Zm-2.5 32.2-12.4-11.9c-5-5-9.9-4.2-13.1-.7-2.2 2.5-3.5 5.4-2 7.9l-9.2-8.9-3 3.2 25.5 25 3-3.2-11.4-11.1c-3.7-3.5-4.5-5.9-1.5-9.2 3-3.2 5.7-2.2 8.9 1l11.6 11.4 3.6-3.5Zm-36.4-2-4.7 3.5-3.2-4.2-2.2 1.7c2.5 3.5 2.2 5.4-.2 7.2l2 2.7 2.2-1.5 7.7 10.4c3.7 5.2 6.9 7.7 12.6 3.7.5-.5 1.2-1 2-1.5l-2.5-3.2c-4.5 3.7-5.2 3.2-8.9-2l-7.2-9.9 4.7-3.5-2.3-3.4Zm-23 14.1-5 2.2c-1.7-4.2-1.2-5.2 1.7-6.7.5-.2 1.2-.5 1.2-.5l-1.5-3.5s-1 .2-2 .7c-5.2 2.2-5.9 5.4-3.5 11.6l-2.7 1.2 1.5 3.5 2.7-1.2 9.2 20.8 4.2-1.7-9.2-20.8 5-2.2-1.6-3.4Zm-22.3 11.7c3.2-.7 5.9.7 6.9 4.5l1.7 7.2c1 3.7-.7 6.4-4 7.2-3.3.8-5.9-.7-6.9-4.5l-1.7-7.2c-1.2-3.8.5-6.5 4-7.2m5.4 22.7c6.2-1.5 8.7-6.4 7.2-12.6l-1.5-6.2c-1.5-6.2-6.2-9.4-12.1-7.9-6.2 1.5-8.9 6.4-7.2 12.6l1.5 6.2c1.5 6.2 5.9 9.4 12.1 7.9m-46.5-14.3c.2-4 2.5-5.9 5.9-5.7 3.5.2 5.4 2.2 5.4 6.4v1.7l-11.1-.5-.2-1.9Zm15.6 1.2c.2-6.4-3.2-10.4-9.7-10.6-6.4-.2-10.2 3.7-10.4 10.2l-.2 6.4c-.2 6.4 3.2 10.6 9.7 10.9 6.2.2 10.2-3.7 10.4-8.4v-.2l-4.5-.2v.5c0 3-2.5 5-5.7 4.7-3.2 0-5.4-2.2-5.4-6.2v-3l15.6.5.2-4.6Zm-21.6-11.6-5.7-1 1-5.2-2.7-.5c-.7 4.2-2.5 5.4-5.4 5l-.5 3.2 2.7.5-2.5 12.6c-1.2 6.2-.7 10.4 5.9 11.6.7.2 1.5.2 2.5.2l.7-4c-5.7-.7-5.9-1.5-4.7-7.7l2.2-12.1 5.7 1 .8-3.6ZM121.1 283l-6.2 15.8c-2.2 5.7 0 10.6 5.9 12.9 5.7 2.2 10.9-.2 12.9-5.9l6.2-15.8-4.2-1.5-6.2 16.6c-1.2 3.2-4.2 4.2-7.2 3-2.7-1-4.7-3.7-3.5-7.2l6.2-16.6-3.9-1.3Zm-13.1-3.7c2.7 1.7 3.7 4.7 1.7 7.9l-4 6.2c-2 3.2-5.2 4-7.9 2.2-3-1.7-3.7-4.7-1.5-8.2l4-6.2c1.7-3.2 4.9-3.7 7.7-1.9m-12.4 19.8c5.2 3.2 10.6 1.7 14.1-3.7l3.2-5.4c3.5-5.4 2.5-10.9-3-14.1-5.4-3.5-10.6-1.7-14.1 3.5l-3.2 5.4c-3.5 5.6-2.5 11.1 3 14.3M88.9 256l3.7 3.5c3 2.7 4 6.2.5 9.9l-.7.7c-3.2 3.5-6.9 3-9.9.2l-3.7-3.5L88.9 256Zm-9.4 17.6-2 11.1 4 3.7 2-12.6c4 2.2 8.4 1.5 12.4-2.5l.7-.7c5.2-5.4 4.7-11.6-.2-16.1l-7.4-6.9-22.8 24.5 3.5 3.2 6.7-6.9 3.1 3.2Zm-19.8-39.9c3.5-2 6.2-1 7.9 2 1.7 3 1 5.7-2.7 7.9l-1.5.7-5.4-9.9 1.7-.7Zm6.9 13.9c5.7-3.2 7.2-8.2 4.2-13.9-3.2-5.4-8.4-6.7-14.1-3.7l-5.7 3.2c-5.7 3.2-7.4 8.4-4.2 13.9 3 5.4 8.4 6.7 12.6 4.5h.2l-2.2-4-.5.2c-2.5 1.5-5.4.5-7.2-2.5-1.5-2.7-1-5.9 2.5-7.9l2.7-1.5 7.7 13.6 4-1.9Zm3.7-35.2L37.4 226l1.7 4.2L72 216.6l-1.7-4.2Zm-19.8 1.8c6.7-1.5 9.7-5.9 7.9-12.4-1.5-6.2-6.4-8.9-12.6-7.2l-6.2 1.5c-6.2 1.5-9.4 6.2-7.9 12.4s6.4 8.7 12.9 7.2l-1-4.2c-4.2 1-6.9-.2-7.7-4-1-3.7 1-6.2 5-6.9l5.7-1.5c5-1.2 7.2 0 8.2 3.7 1 3.7-.7 5.9-5.2 6.9l.9 4.5ZM19.8 181l36.1 10.9-.2-5-20.8-5.7 20.3-7.2-.2-5-26.3 10-9.2-2.7.3 4.7Zm21.8-20.8c-3.7-.5-7.7-2.7-6.9-7.7.5-3.7 3.5-5.9 7.9-5.2l11.4 2c4.7.7 6.2 4.2 5.7 7.4-.7 4.5-4.7 5.7-8.9 5.2l-.7 4.7c6.9 1.2 12.9-2.2 14.1-8.9 1-6.4-3-11.9-9.7-12.9l-11.1-1.7c-6.7-1.2-12.1 2.5-13.4 9.2-1.2 6.9 3.5 11.9 10.6 13.1l1-5.2Z",
    mask: "url(#r)"
  })))));
};
export { SvgLogoWhite as ReactComponent };
export default __webpack_public_path__ + "static/logo-white.5c78f2bf.svg";